<template lang="html">
  <section class="headerTem">
    <div class="headerTitle">新四军管理系统 -- {{$route.meta.title}}</div>
<!--    <div class="webTitle">{{$route.meta.title}}</div>-->

    <el-dropdown trigger="click" @command="handleCommand">
				<span class="el-dropdown-link">
<!--        <img class="header_img" :src="headImage"/>-->
        {{userInfo.username}}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu class="user_el-dropdown-menu" slot="dropdown">
        <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
        <el-dropdown-item command="outLogin">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>





<!--    <div>头像-->
<!--      <el-dropdown @command="handleCommand">-->
<!--        <span class="el-dropdown-link">-->
<!--          <i class="el-icon-setting"></i>-->
<!--        </span>-->
<!--        <el-dropdown-menu slot="dropdown">-->
<!--          <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>-->
<!--          <el-dropdown-item command="outLogin">退出登录</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
<!--    </div>-->








    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="ruleForm" :rules="rules">
        <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
          <el-input class="input" v-model="ruleForm.phone"></el-input>
          <el-button type="primary" @click="sendCode" :disabled="disadle">{{massage}}</el-button>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPassword">
          <el-input class="input" v-model="ruleForm.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="验证码" :label-width="formLabelWidth" prop="verificationCode">
          <el-input class="input" v-model="ruleForm.verificationCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePassword">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import API from "@/api/api";
export default {
  name: "header.vue",
  data() {
    // 密码规则
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      if (!this.$config.passwordReg.test(this.ruleForm.newPassword)) {
        callback(new Error("密码必须大于8位数字且字母大小写"));
      }
    };
    // 验证码规则
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      }
    };
    return {
      userInfo: {},
      dialogFormVisible: false,
      // form表单
      ruleForm: {
        phone: "", // 手机号
        newPassword: "", // 新密码
        verificationCode: "", // 验证码
      },
      formLabelWidth: "100px",
      rules: {
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { max: 11, trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      //
      disadle: false,
      massage: "获取验证码",
    };
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(now, old) {
        // console.log(now, old, "header.vue");
        //  解析token 获取用户信息
        this.handleHeaderRouteChange();
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleHeaderRouteChange() {
      let { userInfo,userRole } = this.$config.analysisToken();
      // console.log(userInfo,userRole)
      this.userInfo = userInfo;
      // this.ruleForm.phone = userInfo.phoneNumber;
    },
    handleCommand(command) {
      console.log(command);
      if (command == "outLogin") {
        this.open();
      } else {
        this.dialogFormVisible = true;
      }
    },
    open() {
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push('/login');
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 发送验证码
    sendCode() {
      console.log("111111");
      let times = 60;
      let setInter = setInterval(() => {
        times--;
        if (times <= 0) {
          this.massage = "获取验证码";
          this.disadle = false;
          clearInterval(setInter);
        } else {
          this.massage = "重新获取(" + times + ")";
          this.disadle = true;
        }
      }, 1000);
      let params = {};
      params.telNum = this.ruleForm.phone;
      API.sendSmsCode(params)
        .then((res) => {
          // this.verificationCode =
          console.log(res, "发送验证码成功");
        })
        .catch((err) => {
          console.log(err, "cw");
        });
    },
    changePassword() {
      let params = {};
      params.phoneNumber = this.ruleForm.phone;
      params.newPassword = this.ruleForm.newPassword;
      params.smsCode = this.ruleForm.verificationCode;
      API.changePassword(params)
        .then((res) => {
          console.log(res, "密码修改成功");
        })
        .catch((err) => {
          console.log(err, "cw");
          // this.$message({
          //   message: err.data,
          //   type: "error",
          // });
        });
    },
  },
};
</script>

<style type="text/css" scoped>
.headerTem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0px 30px;
  font-size: 20px;
  height: 100%;
}
.headerTitle{
  color: #2196f3;
  font-size: 22px;
  color: #666;
  font-weight: 500;
  letter-spacing: 1px;
}
.webTitle{
  color: #2196f3;
  font-size: 22px;
  color: #666;
  font-weight: 500;
  letter-spacing: 1px;
}

.el-dropdown-menu.user_el-dropdown-menu{
  margin-top: 0;
}
.el-dropdown-menu__item {
  text-align: center;
  padding: 0 30px;
}
.el-dropdown-menu /deep/  .popper__arrow {
  display: none;
}

.el-dropdown {
  height: 60px;
  cursor: pointer;
}

.el-dropdown-link {
  display: inline-block;
  height: 60px;
  line-height: 60px;
  padding-right: 10px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: 500;
}
.header_img {
  vertical-align: middle;
  margin-left: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}


.el-dropdown-link.el-dropdown-selfdefine {
  height: 60px;
  line-height: 60px;
}




.el-icon-setting {
  font-size: 30px;
  margin-left: 20px;
}
.el-dropdown-link {
  cursor: pointer;
}
.input {
  width: 300px;
  margin-right: 10px;
}
</style>